import { JobStatusOrCreating } from "@/types/job-status-or-creating";

export const jobIsRunning = (status: JobStatusOrCreating | undefined) =>
  status === "running" || status === "scheduled" || status === "pending" || status === "cancelling";
